/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Leagues_LabelInputs */



/**
* | output |
* | --- |
* | "Restrict to leagues" |
*
* @param {Promo_Leagues_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_leagues_label = /** @type {((inputs?: Promo_Leagues_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Leagues_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Restreindre aux ligues")
	if (locale === "es") return /** @type {LocalizedString} */ ("Restringir a ligas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Restringir a ligas")
	if (locale === "it") return /** @type {LocalizedString} */ ("Limita ai campionati")
	return /** @type {LocalizedString} */ ("Restrict to leagues")
});